import { createHttpLink } from '@apollo/client/link/http'

export const httpLink = createHttpLink({
    uri: process.env.REACT_APP_GRAPHQL_API_URL,
})
